module.exports = __webpack_public_path__ + "static/media/osquery-terminal-listening-ports-2018-05-30.c160bb91.png";